export default __webpack_public_path__ + "static/media/dialer.7df015ac.svg";